/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * Array field representation.
 */
export interface ArrayClaimValue {
    /** The array field value. */
    value: Truvity.CredentialClaimValue[];
}
